import { render, staticRenderFns } from "./StandardCard.vue?vue&type=template&id=fd9f5c3a&scoped=true"
import script from "./StandardCard.vue?vue&type=script&lang=js"
export * from "./StandardCard.vue?vue&type=script&lang=js"
import style0 from "./StandardCard.vue?vue&type=style&index=0&id=fd9f5c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9f5c3a",
  null
  
)

export default component.exports